/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchResultSummary } from './MatchResultSummary';
import {
    MatchResultSummaryFromJSON,
    MatchResultSummaryFromJSONTyped,
    MatchResultSummaryToJSON,
    MatchResultSummaryToJSONTyped,
} from './MatchResultSummary';

/**
 * Result of confirming a match score
 * @export
 * @interface ScoreConfirmationResponse
 */
export interface ScoreConfirmationResponse {
    /**
     * 
     * @type {MatchResultSummary}
     * @memberof ScoreConfirmationResponse
     */
    matchResult: MatchResultSummary;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreConfirmationResponse
     */
    confirmed: boolean;
    /**
     * True when this confirmation finalised the match and advanced the bracket, false when the opposing captain still has to confirm.
     * @type {boolean}
     * @memberof ScoreConfirmationResponse
     */
    completed: boolean;
}

/**
 * Check if a given object implements the ScoreConfirmationResponse interface.
 */
export function instanceOfScoreConfirmationResponse(value: object): value is ScoreConfirmationResponse {
    if (!('matchResult' in value) || value['matchResult'] === undefined) return false;
    if (!('confirmed' in value) || value['confirmed'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    return true;
}

export function ScoreConfirmationResponseFromJSON(json: any): ScoreConfirmationResponse {
    return ScoreConfirmationResponseFromJSONTyped(json, false);
}

export function ScoreConfirmationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreConfirmationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchResult': MatchResultSummaryFromJSON(json['matchResult']),
        'confirmed': json['confirmed'],
        'completed': json['completed'],
    };
}

export function ScoreConfirmationResponseToJSON(json: any): ScoreConfirmationResponse {
    return ScoreConfirmationResponseToJSONTyped(json, false);
}

export function ScoreConfirmationResponseToJSONTyped(value?: ScoreConfirmationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchResult': MatchResultSummaryToJSON(value['matchResult']),
        'confirmed': value['confirmed'],
        'completed': value['completed'],
    };
}

